// <generated-client-wrappers:imports>
import type * as WrapperApi from '../generated/model/models';
import type * as WrapperHttp from '@angular/common/http';
import type * as WrapperRx from 'rxjs';
// </generated-client-wrappers:imports>
import { Injectable } from '@angular/core';
import { OperationsDashboardService } from '../generated/api/operationsDashboard.service';

@Injectable({ providedIn: 'root' })
export class OperationsDashboardClientService {
  constructor(private readonly client: OperationsDashboardService) {}
  // <generated-client-wrappers:methods>
  growth(
    query: WrapperApi.GrowthMetricsQuery,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.GrowthMetricsResponse> {
    if (!this.client)
      throw new Error('OperationsDashboardService is not available');
    return this.client.operationsDashboardGrowth(
      query,
      'body',
      reportProgress,
      options,
    );
  }

  recentAudit(
    limit?: number,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Array<WrapperApi.AdminAuditEventResponse>> {
    if (!this.client)
      throw new Error('OperationsDashboardService is not available');
    return this.client.operationsDashboardRecentAudit(
      limit,
      'body',
      reportProgress,
      options,
    );
  }

  summary(
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.OperationsDashboardSummary> {
    if (!this.client)
      throw new Error('OperationsDashboardService is not available');
    return this.client.operationsDashboardSummary(
      'body',
      reportProgress,
      options,
    );
  }
  // </generated-client-wrappers:methods>
}
